/* information request
 ==================================================================================================== */

var locale = $('html').attr('lang');  // site locale

import datepickerFactory from 'jquery-datepicker';
datepickerFactory($);

import datepickerLocalizerAPI from '../../common/datepickerLocalizerApi.js';
datepickerLocalizerAPI($);

var bootbox =require('bootbox');

// datepicker localization setup
// var datepickerI18nSetup = require('../../../../vendors/datepicker-i18n-setup');
// datepickerI18nSetup(locale);

var CalendarManager = require('../../common/calendar-manager.js');

(function() {

    // update agentComment
    $('#information_request_agentComment').val('Posted from URL: '+window.location.href);
    $('#information_request_houseId').val($('#house-content').data('house-id'));

    $(document).on('submit', '.post-form-container form', function(event){
        event.preventDefault();

        var form = $(this).serialize();
        var parameters = $(this).data('parameters') ? $(this).data('parameters') : null;
        var formActionUrl = parameters != null ? $(this).attr('action') + '/' + parameters : $(this).attr('action');
        var thankYouUrl = $(this).data('endpoint-url');

        var placeholder = $(this).closest('.post-form-container');
        var initialHeight = placeholder.height();

        placeholder.html('<div class="ajax-placeholder"></div>');
        placeholder.find('.ajax-placeholder').css({'height': initialHeight });

        $.post(formActionUrl, form, function(data){
            if (typeof data == 'object' && data.result == 'success') {
                if (thankYouUrl) {
                    if(data.request_id > 0) {}
                    thankYouUrl = thankYouUrl.substring(0, thankYouUrl.length -2) + data.request_id + '/';
                    window.location = thankYouUrl;
                } else {
                    placeholder.replaceWith(data.msg);
                    init();
                }
            } else {
                placeholder.replaceWith(data);
                init();
            }
        });
    });

    function init() {
        $('#information_request_dateFrom').datepicker({
            defaultDate: CalendarManager.calendarStartDate(),
            dateFormat: 'dd-mm-yy',
            prevText: '←',
            nextText: '→',
            onSelect: function () {
                var day = $('#information_request_dateFrom').datepicker('getDate').getDate() + 7;
                var month = $('#information_request_dateFrom').datepicker('getDate').getMonth();
                var year = $('#information_request_dateFrom').datepicker('getDate').getFullYear();
                $('#information_request_dateTo').datepicker('setDate', new Date(year, month, day));
            }
        });

        $('#information_request_dateTo').datepicker({
            defaultDate: CalendarManager.calendarStartDate(),
            dateFormat: 'dd-mm-yy',
            prevText: '←',
            nextText: '→',
            onSelect: function () {
                var startDate = $('#information_request_dateFrom').datepicker('getDate');
                var endDate = $(this).datepicker('getDate');
                var days = (endDate - startDate) / 86400000;

                var minDays = 5;

                if (startDate.getMonth() == 6 || startDate.getMonth() == 7 || endDate.getMonth() == 6 || endDate.getMonth() == 7)
                {
                    minDays = 7;
                }

                if ($('body').has('#specific-house') && $('#cautionText').html()) {
                    if (days < minDays) {
                        bootbox.alert($('#cautionText').html());
                    }
                }
            }

        });
    }

    init();
})();